import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { href: '/#top', label: 'INÍCIO' },
    { href: '/#categorias', label: 'CATEGORIAS' },
    { href: '/#jogar', label: 'JOGAR' },
    { href: '/torneios', label: 'TORNEIOS' },
    { href: '/#distribuidor', label: 'DISTRIBUIDOR' },
  ];

  return (
    <nav className={`fixed left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'top-0 bg-black/85 backdrop-blur-md border-b border-[rgba(34,230,230,0.2)]' : 'top-[36px] bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-14 flex items-center justify-between">
        <a href="/#top" className="font-display font-black tracking-widest text-white text-lg">
          SQUARE<span className="text-[color:var(--sd-cyan)] sd-glow">.DARTS</span>
        </a>
        <div className="hidden md:flex items-center gap-8 font-mono text-xs tracking-[0.25em] text-white/80">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.label.toLowerCase()}`} className={`hover:text-[color:var(--sd-cyan)] transition-colors ${window.location.pathname === l.href ? 'text-[color:var(--sd-cyan)]' : ''}`}>{l.label}</a>
          ))}
          <a href="/#distribuidor" className="sd-btn-outline">CANDIDATAR</a>
        </div>
        <button className="md:hidden text-white" data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-black border-t border-[rgba(34,230,230,0.2)] px-6 py-4 flex flex-col gap-3 font-mono text-sm tracking-[0.25em] text-white/85">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="hover:text-[color:var(--sd-cyan)]">{l.label}</a>
          ))}
        </div>
      )}
    </nav>
  );
}
